import { useState } from 'react'
import { Link } from 'react-router-dom';
import { KeyboardArrowDownRounded, NotificationsNoneRounded } from '../../utils/constants'
import {Button, MainSearch, SubCover, ToggleModeButton} from '../';
import './navbar.css';

const Navbar = ({theme, user}: any) => {
  // const { isLoading, getNotificationsByUser } = useSelector((state) => state?.notificationList)
  // Check if there's any unread notification
  // const hasUnreadNotifications                = getNotificationsByUser.some(notification => !notification.isRead);
  const hasUnreadNotifications                   = null;
  const [isAccountOpen, setIsAccountOpen]        = useState<boolean | null>(null)
  const [isNotification, setIsNotification]      = useState(false);

  const handleAccountClick = () => {
    setIsAccountOpen((prev) => (prev ? null : true));
  }

  const handleCloseCover = () => {
    setIsAccountOpen(null)
  }

  const handleNotificationclick = () => {
    setIsNotification((prev) => !prev)
  }

  return (
    <>
      {user && (
        <nav className='top-navbar-wrapper'>
          <div className='top-navbar-search-wrapper'>
            <MainSearch />
          </div>

          <div className='top-navbar-body-wrapper'>
            {user && (
              <div className='top-navbar-image-menu'>
                <div className={isAccountOpen ? 'top-navbar-image-wrapper active': 'top-navbar-image-wrapper'} onClick={handleAccountClick}>
                  <div className='top-navbar-image'>
                    <img src={user?.selectedFile} alt='' />
                  </div>
                  <KeyboardArrowDownRounded />
                </div>
                <div className={isAccountOpen ? 'top-navbar-image-dropdown-wrapper active' : 'top-navbar-image-dropdown-wrapper'}>
                  <div className='top-navbar-details-wrapper'>
                    <h3 className='top-navbar-details-title'>Drop Down</h3>
                    <div className='top-navbar-details'>
                      <div className='top-navbar-section'>
                        <span className='top-navbar-section-class-title'>Admins</span>
                        <div className='top-navbar-section-class-link'>
                          <a href="/classifications/category">category</a>
                        </div>
                      </div>
                      <div className=''>
                        <span className='top-navbar-section-class-title'>Users</span>

                      </div>
                      <div className=''>
                        <span className='top-navbar-section-class-title'>Posts</span>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className='top-navbar-menu-notification'>
              <Button buttonWrapper={hasUnreadNotifications === null ? "top-navbar-notification-btn-wrapper active" : "top-navbar-notification-btn-wrapper"} onClickButton onClickNavigate={handleNotificationclick} buttonIcon={<NotificationsNoneRounded />} />

              <div className={isNotification ? 'top-navbar-detail-menu-notification active' : 'top-navbar-detail-menu-notification'}>
                {/* <Notification isNotificationToggle={handleNotificationclick} user={user} isLoading={isLoading} getNotificationsByUser={getNotificationsByUser} /> */}
              </div>
            </div>
            <div className='switch-wrapper'>
              <ToggleModeButton theme={theme} />
            </div>
          </div>
        </nav>
      )}

      {isAccountOpen !== null && (
        //z-index: 3, others should be higher
        <SubCover handleCloseCover={handleCloseCover} />
      )}
    </>
  )
}

export default Navbar